import React from 'react';
import { Link } from 'react-router-dom';
import MedicalSupplies from "../../assests/medical_supplies.jpg";
import RiceBag from "../../assests/rice_bag.jpg";
import ewingMachine from "../../assests/machine.jpg";
import Chickens from "../../assests/chicken.jpg";
import Cow from "../../assests/cow.jpg";
import WaterWell from "../../assests/water_well.jpg";
import DentalChair from "../../assests/dental_chair.jpg";
import RicePaddy from "../../assests/rice_paddy.jpg";

function ProvidingHumanitarianAid() {
  const cost = (text) => (
    <span style={{ color: "#c47a1e", fontWeight: 700 }}>{text}</span>
  );

  const projects = [
    {
      no: "#1",
      title: "Medical Supplies",
      video: "",
      image: MedicalSupplies,
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=FEE7KURVDBSHU",
      paragraphs: [
        <>
          Your gift will provide first aid supplies for a one-day medical
          mission outreach. {cost("Medical supplies would cost $50.")}
        </>,
        <>Would you consider donating for medical supplies?</>,
      ],
    },
    {
      no: "#2",
      title: "Cooking Pots",
      video: "https://www.youtube.com/embed/r4EVM3zpCoE",
      image: "",
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=EQQZJNSEMPVDL",
      paragraphs: [
        <>
          To feed the campus, the kitchen cooks 2000 meals per day, burning
          the bottom out of the cooking pots. They have to be replaced every
          year. {cost("Cooking pots would cost $100.")}
        </>,
        <>Would you consider providing some cooking pots?</>,
      ],
    },
    {
      no: "#3",
      title: "Rice Bag",
      video: "",
      image: RiceBag,
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=MH4MUYKQ3VMRE",
      paragraphs: [
        <>
          Bring the nourishment and comfort of a steaming bowl of rice to
          hungry children and their families on the campus. Many bags of rice
          are necessary to feed the children, students and staff on the campus
          every day. {cost("One bag of rice would cost $100.")}
        </>,
        <>Would you consider providing a bag of rice?</>,
      ],
    },
    {
      no: "#4",
      title: "Sewing Machine",
      video: "",
      image: ewingMachine,
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=DP5EXXE3BGJGW",
      paragraphs: [
        <>
          Many women in India have no means of earning a living. By purchasing
          a sewing machine, you are giving a woman the tool she needs to
          provide an income for her family.{" "}
          {cost("One sewing machine would cost $125.")}
        </>,
        <>Would you consider giving a sewing machine?</>,
      ],
    },
    {
      no: "#5",
      title: "Chickens",
      video: "",
      image: Chickens,
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=WMMK5FP42KHSQ",
      paragraphs: [
        <>
          Help us to purchase land so we can raise chickens for eggs to feed
          the campus and produce income.{" "}
          {cost("Our chickens' project would cost $500.")}
        </>,
        <>Would you consider contributing to our chickens' project?</>,
      ],
    },
    {
      no: "#6",
      title: "Buy a Cow",
      video: "",
      image: Cow,
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=KK3BPH8Y77SML",
      paragraphs: [
        <>
          Our cows provide 100% of the milk, consumed on campus, for our
          students and staff.{" "}
          {cost("The total cost of a cow would be $1,200.")}
        </>,
        <>Would you consider participating in buying a cow?</>,
      ],
    },
    {
      no: "#7",
      title: "Water Well",
      video: "",
      image: WaterWell,
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=NA7CQNBH8A63A",
      paragraphs: [
        <>
          In the villages, many are getting sick or dying from impure water.
          Help give the gift of clean water to the communities we serve.{" "}
          {cost(
            "To purchase a water well, the motor and the pump would cost respectively $500 and $1,500."
          )}
        </>,
        <>Would you consider helping us to provide a water well?</>,
      ],
    },
    {
      no: "#8",
      title: "Dental Chair",
      video: "",
      image: DentalChair,
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=VVBGTRVHGTML8",
      paragraphs: [
        <>
          Provide specialized dental equipment in order to ensure the campus
          has access to quality dental care.{" "}
          {cost("One dental chair would cost $5,000.")}
        </>,
        <>Would you consider participating in getting a dental chair?</>,
      ],
    },
    {
      no: "#9",
      title: "Rice Paddy",
      video: "",
      image: RicePaddy,
      donateUrl:
        "https://www.paypal.com/donate/?hosted_button_id=BEQ8QX3ACMG3S",
      paragraphs: [
        <>
          Rice is served with most meals on campus. Each year, the cost of rice
          and vegetables rises.
        </>,
        <>
          Help us alleviate our monthly cost by purchasing 20 acres to
          cultivate rice. Each acre would produce two harvests that could feed
          our campus for three weeks.{" "}
          {cost("One acre would cost $20,000.")}
        </>,
        <>Would you consider helping us in buying one acre at a time?</>,
      ],
    },
  ];

  return (
    <div
      style={{
        fontFamily: "'Georgia','Times New Roman',serif",
        color: "#222",
        backgroundColor: "#fff",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "0 1.5rem 3.5rem",
        }}
      >
        {/* Back link */}
        <Link
          to="/"
          style={{
            fontSize: "13px",
            color: "#c47a1e",
            textDecoration: "none",
            display: "inline-block",
            margin: "1.5rem 0 0",
            userSelect: "none",
          }}
        >
          ← Back to Home
        </Link>

        {/* Heading */}
        <h1
          style={{
            fontFamily: "'Dancing Script','Brush Script MT',cursive",
            fontSize: "2.4rem",
            color: "#c47a1e",
            margin: "1.2rem 0 0.15rem",
            fontWeight: 700,
          }}
        >
          Humanitarian Aid
        </h1>

        <div
          style={{
            display: "flex",
            gap: "4px",
            marginBottom: "2.2rem",
          }}
        >
          {[...Array(9)].map((_, i) => (
            <div
              key={i}
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                backgroundColor: "#c47a1e",
              }}
            />
          ))}
        </div>

        {/* Two-column grid */}
        <div
          className="humanitarian-aid-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "2.5rem 2.5rem",
          }}
        >
          {projects.map((p, i) => (
            <div key={i}>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#888",
                  marginBottom: "0.6rem",
                }}
              >
                {p.no}
              </p>

              <div
                style={{
                  width: "100%",
                  borderRadius: "4px",
                  overflow: "hidden",
                  marginBottom: "1rem",
                }}
              >
                {p.video ? (
                  <iframe
                    width="100%"
                    height="230"
                    src={p.video}
                    title={p.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      border: "none",
                      display: "block",
                    }}
                  />
                ) : (
                  <img
                    src={p.image}
                    alt={p.title}
                    style={{
                      width: "100%",
                      height: "230px",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                )}
              </div>

              <h3
                style={{
                  fontSize: "1.05rem",
                  fontWeight: 700,
                  color: "#222",
                  margin: "0 0 0.6rem",
                }}
              >
                {p.title}
              </h3>

              {p.paragraphs.map((para, j) => (
                <p
                  key={j}
                  style={{
                    fontSize: "13.5px",
                    lineHeight: "1.75",
                    color: "#444",
                    marginBottom: "0.75rem",
                  }}
                >
                  {para}
                </p>
              ))}

              {/* PayPal GIVE link */}
              <a
                href={p.donateUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  background: "#e87b1e",
                  color: "#fff",
                  padding: "9px 26px",
                  fontSize: "12px",
                  fontWeight: "700",
                  cursor: "pointer",
                  fontFamily: "inherit",
                  letterSpacing: "0.5px",
                  textDecoration: "none",
                }}
              >
                GIVE
              </a>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 720px) {
          .humanitarian-aid-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
}

export default ProvidingHumanitarianAid;
